<app-page-title icon="fa-paper-plane-o" title="Envios da automação" data-testid="integration-sends-section">
  <a class="btn btn-secondary" [routerLink]="['/integration-sms/view', source]">
    <i class="fa fa-arrow-left"></i> Voltar
  </a>
</app-page-title>

<div class="card mb-3">
  <div class="row align-items-center">
    <div class="col-md-8 col-sm-12">
      <label>Automação</label>
      <h5 class="automation-name" data-testid="sends-automation-name">{{ automationLabel }}</h5>
    </div>
    <div class="col-md-4 col-sm-12 text-right" *ngIf="result">
      <label>Mensagens encontradas</label>
      <p data-testid="sends-total">{{ result.total | numberFormat }}</p>
    </div>
  </div>
</div>

<form (submit)="search(1)">
  <div class="row col-md-12">
    <div class="col-md-12 col-sm-12" style="width: fit-content">
      <mat-form-field>
        <mat-label>Data inicial</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="startedMonth" name="startedMonth" />
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-md-12 col-sm-12" style="width: fit-content">
      <mat-form-field>
        <mat-label>Data final</mat-label>
        <input matInput [matDatepicker]="picker2" [(ngModel)]="endedMonth" name="endedMonth" />
        <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
    </div>
  </div>

  <div class="row col-md-12 col-sm-12">
    <div class="col-md-4 col-sm-12 form-group">
      <label>Telefone</label>
      <input
        type="text"
        name="phone"
        [(ngModel)]="phone"
        class="form-control"
        placeholder="(99) 99999-9999"
        data-testid="input-phone-filter"
      />
    </div>
    <div class="col-md-4 col-sm-12 form-group">
      <label>Mensagem</label>
      <input
        type="text"
        name="text"
        [(ngModel)]="text"
        class="form-control"
        placeholder="Trecho da mensagem"
        data-testid="input-message-filter"
      />
    </div>
    <div class="col-md-3 col-sm-12 form-group">
      <label>Status</label>
      <select name="status" class="form-control" [(ngModel)]="status" data-testid="select-status-filter">
        <option value="">Todos</option>
        <option *ngFor="let item of statuses" [value]="item.id">{{ item.name }}</option>
      </select>
    </div>
    <div class="col-md-1 col-sm-12 d-flex align-items-end mb-3">
      <!--
        Ver o comentário do nível 1. Aqui o duplo disparo não chegava a virar duas
        requisições só por acidente: a 2ª navegação ia para a MESMA URL e o
        `onSameUrlNavigation: 'ignore'` a descartava. Não é garantia para se
        apoiar — um filtro que mude entre as duas chamadas quebraria isso.
      -->
      <button class="btn btn-primary me-1" type="submit" [disabled]="invalidPeriod" data-testid="btn-search-sends">
        <i class="fa fa-search"></i>
      </button>
    </div>
  </div>

  <!-- Mesmo aviso do nível 1: uma mensagem para o par, o botão desabilitado junto. -->
  <div class="row col-md-12" *ngIf="invalidPeriod">
    <small class="text text-danger" data-testid="invalid-period">
      Período inválido: a data inicial é posterior à final.
    </small>
  </div>

  <div class="row col-md-12 mb-3">
    <div class="col">
      <a class="btn btn-secondary btn-sm" (click)="clearFilters()" data-testid="btn-clear-filters">
        Limpar filtros
      </a>
    </div>
  </div>
</form>

<app-skeleton *ngIf="loading" variant="table-row" [count]="8" [columns]="4"
  label="Carregando os envios" data-testid="sends-loading"></app-skeleton>

<div *ngIf="!loading && result?.data.length > 0; else notFound">
  <table class="table" data-testid="sends-table">
    <thead>
      <tr>
        <th>Telefone</th>
        <th>Mensagem</th>
        <th>Data envio</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let send of result.data" data-testid="send-row">
        <td data-testid="send-phone">{{ phoneOf(send) }}</td>
        <td class="text-break">{{ send.message }}</td>
        <td>{{ sentDateOf(send) | date : "dd/MM/yyyy, H:mm" }}</td>
        <td data-testid="send-status">{{ send.broadcast_status_id | broadcastStatus }}</td>
      </tr>
    </tbody>
  </table>

  <app-pagination
    [currentPage]="result.current_page"
    [itemsPerPage]="result.per_page"
    [totalItems]="result.total"
    (pageChanged)="search($event)"
  ></app-pagination>
</div>

<ng-template #notFound>
  <div class="card" *ngIf="!loading">
    <div class="col" data-testid="no-sends">
      Nenhuma mensagem encontrada para os filtros informados.
    </div>
  </div>
</ng-template>
